export const GET_USER_TEAMS = channelName => `users/teams/${channelName}`;
export const GET_USER_CHATWORK = id => `users/chatwork/${id}`;
export const GET_CURRENT_USER = 'users/me';